import { Step } from "../../types/Step";
import { INavigatorItemConfig } from "../../App/Components/Navigator";
import NavigatorItemId from "../../App/types/NavigatorItemId";
import AllMedicalQuestionsEvaluator from "../../steps/Medical/compositions/AllMedicalQuestionsEvaluator";

const LegacyScreeningNavigatorConfiguration: INavigatorItemConfig = {
  id: NavigatorItemId.Screening,
  label: "Screening",
  isDisabled: () => false,
  onClickStep: Step.qualify,
  lastStep: Step.medicalDiabetic
};

const SingleMedicalStepScreeningNavigatorConfiguration: INavigatorItemConfig = {
  id: NavigatorItemId.Screening,
  label: "Screening",
  isDisabled: () => false,
  onClickStep: Step.qualify,
  lastStep: Step.medicalAll
};

const SchedulingNavigatorConfiguration: INavigatorItemConfig = {
  isDisabled: ({ medicalForm }) =>
    !AllMedicalQuestionsEvaluator.isComplete(medicalForm) || AllMedicalQuestionsEvaluator.isNonCandidate(medicalForm),
  id: NavigatorItemId.Scheduling,
  label: "Scheduling",
  onClickStep: Step.centerSelection,
  lastStep: Step.scheduling
};

/** The default navigator configuration for the no-confirmation variant (books directly from scheduling). */
export const NoConfirmationDefaultNavigatorConfiguration: INavigatorItemConfig[] = [
  LegacyScreeningNavigatorConfiguration,
  SchedulingNavigatorConfiguration
];

/** The default navigator configuration for the single-medical-step treatment variant. */
export const SingleMedicalStepDefaultNavigatorConfiguration: INavigatorItemConfig[] = [
  SingleMedicalStepScreeningNavigatorConfiguration,
  SchedulingNavigatorConfiguration
];

/** The navigator configuration for pre-qualified patients in the no-confirmation variant. */
export const NoConfirmationPreQualifiedPatientNavigatorConfiguration: INavigatorItemConfig[] = [
  SchedulingNavigatorConfiguration
];

/** The navigator configuration for pre-qualified patients in the treatment variant. */
export const SingleMedicalStepPreQualifiedPatientNavigatorConfiguration =
  NoConfirmationPreQualifiedPatientNavigatorConfiguration;
